package com.vizio.redwolf.utils

import kotlin.js.JsExport

@JsExport
interface WatchlistEnvironment : Environment {
    val watchlistHost: String
    val path: String
}

@JsExport
abstract class BaseWatchlistEnvironment(override val path: String = "/v1") : WatchlistEnvironment

@JsExport
data class DevWatchlistEnvironment(
    override val watchlistHost: String = "watchlist-dev.smartcasttv.com",
) : BaseWatchlistEnvironment()

@JsExport
data class StageWatchlistEnvironment(
    override val watchlistHost: String = "watchlist-stage.smartcasttv.com",
) : BaseWatchlistEnvironment()

@JsExport
data class ProdWatchlistEnvironment(
    override val watchlistHost: String = "watchlist-prod.smartcasttv.com",
) : BaseWatchlistEnvironment()

@JsExport
data class TestWatchlistEnvironment(
    override val watchlistHost: String = "watchlist-test.smartcasttv.com",
) : BaseWatchlistEnvironment()

fun chooseWatchlistEnvironment(envConfig: WatchlistEnvironmentConfig): WatchlistEnvironment {
    return when (envConfig.environmentGroup) {
        EnvironmentGroup.PROD -> ProdWatchlistEnvironment()
        EnvironmentGroup.PREPROD -> TODO("PREPROD Environment for AvodEnvironment not defined yet!")
        EnvironmentGroup.STAGE -> StageWatchlistEnvironment()
        EnvironmentGroup.DEV -> DevWatchlistEnvironment()
        EnvironmentGroup.TEST -> TestWatchlistEnvironment()
    }
}


